import type { ReactNode } from 'react';
import { Icon } from './Icon';

interface TopBarProps {
  title: string;
  backHref?: string;
  right?: ReactNode;
}

export function TopBar({ title, backHref = '#/', right }: TopBarProps) {
  return (
    <header className="topbar">
      <a className="back-button" href={backHref} aria-label="Назад">
        <Icon name="arrow-left" />
      </a>
      <h1 className="topbar__title">{title}</h1>
      <div className="topbar__side">{right}</div>
    </header>
  );
}
